// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1qVou","right":"styles_right__3Xhji"};